import _classCallCheck from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/nakednews/nakednews-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ChatManagerInstance from "./ChatManager";
import FirebaseNodeSanitizerInstance from "./FirebaseNodeSanitizer";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";
import * as log from "loglevel";

var FirebaseBaseSession = /*#__PURE__*/function () {
  function FirebaseBaseSession(id) {
    _classCallCheck(this, FirebaseBaseSession);

    this.id = id;
    log.setLevel(ChatManagerInstance.logLevel);
  }

  _createClass(FirebaseBaseSession, [{
    key: "connect",
    value: function connect(accessData, connectHandler) {
      this.firebaseSettings = {
        prefix: accessData.firebasePrefix,
        Url: accessData.firebaseUrl,
        token: accessData.firebaseToken
      };
      this.firebaseSettings.config = JSON.parse(accessData.firebaseClientJson);
      this.firebaseApp = initializeApp(this.firebaseSettings.config, "firebaseApp:" + this.id);
      var auth = getAuth(this.firebaseApp);
      signInWithCustomToken(auth, this.firebaseSettings.token).then(function () {
        log.trace("firebase authentication succeded!");
        connectHandler();
      }).catch(function (error) {
        log.error("error during authentication : " + error.message);
        connectHandler(error);
      });
    }
  }, {
    key: "getReference",
    value: function getReference(baseNode, terminalNode) {
      var database = getDatabase(this.firebaseApp);
      return ref(database, "cs/" + baseNode + "/" + this.firebaseSettings.prefix + "/" + terminalNode);
    }
  }, {
    key: "addNodeUpdateListener",
    value: function addNodeUpdateListener(baseNode, terminalNode, nodeUpdateListener) {
      var nodeReference = this.getReference(baseNode, FirebaseNodeSanitizerInstance.encodeKey(terminalNode));
      onValue(nodeReference, nodeUpdateListener);
    }
  }]);

  return FirebaseBaseSession;
}();

export { FirebaseBaseSession as default };